<script>
    import { createEventDispatcher, onMount } from "svelte";
    import Quill from "quill";
    import { sgettext } from "../i18n";

    const dispatch = createEventDispatcher();
    
    export let editorCommentLabel = "";
    export let editorCommentLabelTooltip = "";
    export let commentErrors = "";

    onMount(() => {
        var quill = new Quill("#rich-text-input-editor", {
            modules: {
                toolbar: {
                    container: "#toolbar"
                }
            },
            placeholder: sgettext('$$ENTER_COMMENT_1$$'),
        });

        quill.on('text-change', function() {
            if(quill.getLength() <= 1){
                // handles the edge case when user enters something and deletes all of it
                // but quill retains a \n newline character resulting in a min length of 1
                // setting 'text' to empty string helps with form valid in this case
                dispatch("textChange", { text: "" });
            } else {
                dispatch("textChange", { text: quill.root.innerHTML });
            }
        });
    })
</script>

<label for="rich-text-input-parent">
  {editorCommentLabel}*
  {#if editorCommentLabelTooltip}
    <a
      href="#"
      data-toggle="tooltip"
      data-html="true"
      title={editorCommentLabelTooltip}
      style="color:#ccc; margin-left:5px;"
    >
      <i class="fas fa-question-circle" />
    </a>
  {/if}
  {#if commentErrors}
    <small class="text-danger">
      {commentErrors}
    </small>
  {/if}
</label>
<div id="rich-text-input-parent" style="border-radius: 5px;">
  <div
    id="toolbar"
    style="border: 1px solid #ddd; border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom: 0;"
  >
    <button class="btn ql-bold" title={sgettext('$$BOLD_1$$')}
      ><i class="fa fa-bold" /></button
    >
    <button class="btn mx-0 ql-italic" title={sgettext('$$ITALIC_1$$')}
      ><i class="fa fa-italic" /></button
    >
    <button class="btn mx-0 ql-underline" title={sgettext('$$UNDERLINE$$')}
      ><i class="fa fa-underline" /></button
    >
    <button class="btn ql-list" value="ordered"
      ><i class="fa fa-list-ol" title={sgettext('$$NUMBERED_LIST$$')} /></button
    >
    <button class="btn ql-list" value="unordered"
      ><i class="fa fa-list" title={sgettext('$$BULLETED_LIST$$')} /></button
    >
  </div>
  <div
    id="rich-text-input-editor"
    class="ql-editor ql-container rti-editor form-control {commentErrors
      ? 'is-invalid error-boundary'
      : ''}"
  />
</div>

<style>
  .rti-editor {
    border: 1px solid #ddd;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    font-size: 16px;
    max-height: 300px;
    overflow-y: auto;
    padding-left: 3px;
  }

  .error-boundary {
    border: 1px solid #d9534f !important;
  }
</style>
